/*
 * HomeReducer
 *
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 */

import produce from "immer";
import {
  LOADER_STATUS,
  PROFILE_INFO,
  SET_VARIANCE_DATA,
  SET_TAXTURNOVER_DATA,
  SET_TAXLIBALITY_DATA,
  SET_CLEAR_GRAPH
} from "./constants";

// The initial state of the App
export const initialState = {
  loaderStatus: false,
  profileData: [],
  varianceData: [],
  taxTurnOverData: [],
  taxLibalityData: []
};

/* eslint-disable default-case, no-param-reassign */
const AnalyticsGSRT1VS3BReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADER_STATUS:
      return {
        ...state,
        loaderStatus: action.loaderStatus
      };
    case PROFILE_INFO:
      return {
        ...state,
        profileData: action.profileData
      };
    case SET_VARIANCE_DATA:
      return {
        ...state,
        varianceData: action.varianceData
      };
    case SET_TAXTURNOVER_DATA:
      return {
        ...state,
        taxTurnOverData: action.taxTurnOverData
      };
    case SET_TAXLIBALITY_DATA:
      return {
        ...state,
        taxLibalityData: action.taxLibalityData
      };
    case SET_CLEAR_GRAPH:
      return {
        ...state,
        taxLibalityData: [],
        taxTurnOverData: [],
        varianceData: []
      };
    default:
      return state;
  }
};

export default AnalyticsGSRT1VS3BReducer;
